export default __webpack_public_path__ + "static/media/mad_molecule_add.576fddd8.png";